import serviceBase from '@/services/serviceBase'

class contratoService extends serviceBase {
    constructor() {
        super(process.env.VUE_APP_API_ENDPOINT)
    }

    getContratoValido() {
        return this.get(`${this.getSubdominio()}/contrato/valido`)
    }

    
}

export default new contratoService()